// Vite 8's Rolldown bundler splits/evaluates chunks differently and broke that ordering in prod builds
// so jquery-setup  must run first in the import order

import '~/globals/jquery-setup';

const { I18n, getCurrentUser, getExternalUser, APP_CONSTANTS, AppState, $, ENV_VARS, env, getUrlParameters } = window;

export { I18n, getCurrentUser, getExternalUser, APP_CONSTANTS, AppState, $, ENV_VARS, env, getUrlParameters };
